import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { Dispatch } from 'models/meta/action';
import { finishWorkflow } from 'store/actions/workflow';

import { ConsentFinalisedDispatchProps } from './ConsentFinalised.types';
import ConsentFinalised from './ConsentFinalised.layout';


const mapDispatchToProps = (dispatch: Dispatch): ConsentFinalisedDispatchProps =>
    ({ dispatchFinishWorkflow: () => dispatch(finishWorkflow()) });

export default connect(null, mapDispatchToProps)(withTranslation('result-screen')(ConsentFinalised));
